import ClinicDetails from "@page-containers/locations/clinic-details";

export default ClinicDetails;
